export {
  OnboardingQuestionText,
  OnboardingQuestionTextProps,
} from './OnboardingQuestionText';
